import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import Keycloak from "keycloak-js"
import { datadogRum } from '@datadog/browser-rum';
// import "@radix-ui/themes/styles.css";
// import { Theme } from "@radix-ui/themes";
// import './index.css';


axios.defaults.baseURL = process.env.REACT_APP_DASH_API_URL;
const keycloak = new Keycloak("/keycloak.json")

keycloak
	.init({ onLoad: 'login-required', KeycloakResponseType: 'code' })
	.then((auth) => {
		if (!auth) {
			window.location.reload();
		} else {

			datadogRum.init({
				applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
				clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
				site: 'datadoghq.com',
				service: 'qi-sign-dashboard',
				env: process.env.REACT_APP_ENV,
				version: '1.0.0',
				sessionSampleRate: 100,
				sessionReplaySampleRate: 100,
				defaultPrivacyLevel: 'mask-user-input',
			});

			datadogRum.setUser({
				id: keycloak?.tokenParsed?.sub ?? 'unknown',
				email: keycloak?.tokenParsed?.email,
				username: keycloak?.tokenParsed?.preferred_username,
				role: keycloak?.tokenParsed?.realm_access?.roles,
			});

			axios.defaults.headers = { "Authorization": keycloak.token }
			const root = ReactDOM.createRoot(document.getElementById('root'));
			root.render(
				<React.StrictMode>
					{/* <Theme> */}
						<App keycloak={keycloak} />
					{/* </Theme> */}
				</React.StrictMode>
			);
		}
	})
	.catch((err) => {
		console.error("Authenticated Failed", err);
	});



reportWebVitals();
